import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2 } from 'lucide-react';
export function FinalCTASection() {
  const checkoutUrl = 'https://pay.hotmart.com/F104765975P?checkoutMode=10';
  return <section className="py-16 md:py-24 px-4 bg-forest text-white relative" data-id="element-71">
      <div className="max-w-3xl mx-auto text-center" data-id="element-72">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-gold mb-8" data-id="element-73">
          Es Tu Momento
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-cream/90 mb-12" data-id="element-74">
          <p data-id="element-75">
            Durante demasiado tiempo has buscado la solución en lo que comes al
            mediodía.
          </p>
          <p className="font-bold text-white" data-id="element-76">
            La solución siempre estuvo en lo que comes de noche.
          </p>
          <p data-id="element-77">
            Tienes el método ahora mismo. A $6.39 USD. Con garantía total de 30
            días.
          </p>
          <p className="italic text-gold" data-id="element-78">
            No hay razón para esperar una semana más. Una noche más. Un espejo
            más.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-2xl text-dark max-w-xl mx-auto" data-id="element-79">
          <div className="mb-6" data-id="element-80">
            <p className="text-sm font-bold text-urgency uppercase tracking-wider mb-2" data-id="element-81">
              Precio de Lanzamiento
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-82">
              <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-83">
                $29.00
              </span>
              <span className="text-5xl font-serif font-bold text-forest" data-id="element-84">
                $6.39 <span className="text-xl" data-id="element-85">USD</span>
              </span>
            </div>
          </div>

          <CTAButton text="OBTENER MI PROTOCOLO AHORA" href={checkoutUrl} variant="primary" className="text-xl py-4 mb-6" data-id="element-86" />

          <div className="text-sm text-dark/70 space-y-2 text-left bg-cream p-4 rounded-xl" data-id="element-87">
            <p className="font-bold text-center mb-2 text-forest" data-id="element-88">
              ¿Aún tienes dudas? Recuerda:
            </p>
            <div className="grid grid-cols-1 gap-2" data-id="element-89">
              <p className="flex items-center gap-2" data-id="element-90">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-91" />{' '}
                Garantía completa de 30 días
              </p>
              <p className="flex items-center gap-2" data-id="element-92">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-93" />{' '}
                Acceso inmediato tras la compra
              </p>
              <p className="flex items-center gap-2" data-id="element-94">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-95" /> 15
                minutos por noche es todo lo que necesitas
              </p>
              <p className="flex items-center gap-2" data-id="element-96">
                <CheckCircle2 size={16} className="text-success shrink-0" data-id="element-97" />{' '}
                Diseñado para mujeres de más de 35 años
              </p>
            </div>
          </div>

          <p className="text-xs text-dark/50 mt-6 italic" data-id="element-98">
            Al completar tu compra recibirás acceso inmediato a todos los
            materiales en formato digital PDF. Compatible con todos los
            dispositivos.
          </p>
        </div>

        <div className="mt-12 text-cream/80 text-lg" data-id="element-99">
          <p className="font-bold text-white mb-2" data-id="element-100">
            La única decisión equivocada es no tomar ninguna.
          </p>
          <p data-id="element-101">Tu cuerpo lleva tiempo pidiéndote esto.</p>
          <p data-id="element-102">Esta noche puedes empezar a escucharlo.</p>
        </div>
      </div>
    </section>;
}